import React, { FC, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { cyan } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { routes } from '../../data/routes.json';
import kaleMedikaLogo from '../../assets/images/kale_medika_logo.png';

const Logo = styled.img`
  width: 180px;
`;

const drawerWidth = 240;

const NavbarMui: FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navigate = useNavigate();

  const handleClick = (key: string) => {
    navigate(key);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{ background: cyan[300] }}>
        <Logo src={kaleMedikaLogo} alt="logo" />
      </Box>
      <Divider />
      <List>
        {routes.map(({ name, value }) => (
          <ListItem key={name} onClick={() => handleClick(name)} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primary={value} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box>
      <AppBar component="nav" sx={{ background: cyan[300] }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ '&:hover': { cursor: 'pointer' } }} onClick={() => handleClick('/')}>
            <Logo src={kaleMedikaLogo} alt="logo" />
          </Box>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, color: 'black', display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            {routes.map(({ name, value }) => (
              <Button
                key={name}
                onClick={() => handleClick(name)}
                sx={{ fontSize: 16, color: 'black', ml: 3, '&:hover': { background: cyan[400] } }}
              >
                {value}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          variant="temporary"
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default NavbarMui;
